import React from 'react';
import PropTypes from 'prop-types';
import { cardProviders } from '../../../../../screens/Card/constants';
import { useUserCardProvider } from '../../../../../utilities/sharedHooks/user';

const POSITIONS = {
  [cardProviders.MONAVATE]: {
    x: 15,
    y: 120,
    fontSize: 15.27,
    fontWeight: 500,
  },
  [cardProviders.GALILEO]: {
    x: 15,
    y: 130,
    fontSize: 15.27,
    fontWeight: 500,
    fontFamily: 'HM Alpha Mono',
  },
};

export function CardHolderDisplayName({ displayName = '' }) {
  const { cardProvider } = useUserCardProvider();
  const {
    x = 15,
    y = 200,
    fontWeight = 'bold',
    fontSize = 16,
    fontFamily = 'Open Sans',
  } = POSITIONS[cardProvider] || {};
  return (
    <g>
      <text
        fill="#142633"
        fontWeight={fontWeight}
        fontSize={fontSize}
        fontFamily={fontFamily}
        x={x}
        y={y}>
        {displayName}
      </text>
    </g>
  );
}
CardHolderDisplayName.propTypes = {
  displayName: PropTypes.string,
};
export default CardHolderDisplayName;
